export default __webpack_public_path__ + "static/media/bg15.495d7eaa.jpg";